import * as Yup from 'yup'

import env from '../../../../networkRequests/apiClient/env.config'
import { DEFAULT_CURRENCY } from '../../../../shared/dictionaries/currencies.dictionary'
import { AddItemFormValues } from './AddItemForm.types'

export const INITIAL_FORM_VALUES: AddItemFormValues = {
  description: '',
  quantity: '1',
  declaredValue: '',
  currency: DEFAULT_CURRENCY
}

export const MAX_PHOTO_SIZE_BYTES = env.MAX_FULFILLMENT_ITEM_PHOTO_SIZE_MB * 1024 * 1024

export const MAX_PHOTO_SIZE_EXCEEDED_MESSAGE = `Photo size must be less than ${env.MAX_FULFILLMENT_ITEM_PHOTO_SIZE_MB}MB`

export const ALLOWED_PHOTO_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp']

export const ALLOWED_PHOTO_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp']

export const PHOTO_ACCEPT_ATTRIBUTE = ALLOWED_PHOTO_MIME_TYPES.join(',')

export const INVALID_PHOTO_TYPE_MESSAGE = 'Photo must be a JPEG, PNG, or WebP image'

export const addItemValidationSchema = Yup.object({
  description: Yup.string().trim().required('Description is required'),
  quantity: Yup.number()
    .transform((value) => (value === '' || value == null ? undefined : Number(value)))
    .typeError('Must be a valid number')
    .integer('Must be a whole number')
    .min(1, 'Quantity must be at least 1')
    .max(100, 'Quantity must be 100 or less')
    .required('Quantity is required'),
  declaredValue: Yup.number()
    .transform((value) => (value === '' || value == null ? undefined : Number(value)))
    .typeError('Must be a valid number')
    .positive('Must be greater than 0')
    .required('Declared value is required'),
  currency: Yup.string().required('Currency is required')
})
